import React from "react";
import { IntlProvider, FormattedMessage } from "react-intl";
import { useNetwork } from "../../../components/NetworkProvider";
import { useNavigate } from "react-router-dom";
import messages_en from "../translations/en.json";
import messages_fr from "../translations/fr.json";

import { HiOutlineLockClosed, HiArrowLeft } from "react-icons/hi2";

const messages = {
    en: messages_en,
    fr: messages_fr,
};

const Unauthorized = () => {
    const { locale } = useNetwork();
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <IntlProvider locale={locale} messages={messages[locale]}>
            <div className="relative h-screen">
                {/* Back arrow button */}
                <button
                    onClick={handleGoBack}
                    className="absolute top-6 left-4 p-2 rounded-full hover:bg-gray-100 transition-colors duration-200"
                    aria-label="Go back"
                >
                    <HiArrowLeft size={24} className="text-gray-700" />
                </button>

                {/* Main content */}
                <div className="flex flex-col items-center justify-center h-full gap-5 text-base px-10">
                    <HiOutlineLockClosed size={50} className="text-gray-900" />
                    <p className="text-lg font-semibold text-gray-700">
                        <FormattedMessage id="unauthorized.title" />
                    </p>
                </div>
            </div>
        </IntlProvider>
    );
};

export default Unauthorized;
